export default __webpack_public_path__ + "static/media/HomeLogo1.5196525c.png";